import ReactGA from 'react-ga4';

import { config } from '@/config';

const GA_TRACKING_ID = config.GA_TRACKING_ID;
let isInitialized = false;

export const initGA = () => {
  if (!GA_TRACKING_ID) return;
  ReactGA.initialize(GA_TRACKING_ID);
  ReactGA.gtag('set', 'environment', config.ENVIRONMENT);
  console.log(`GA initialized for environment: ${config.ENVIRONMENT}`);
  isInitialized = true;
};

export const trackPageView = (url: string) => {
  if (!isInitialized) return;
  ReactGA.send({
    hitType: 'pageview',
    page: url,
  });
};

export const trackEvent = (
  category: string,
  action: string,
  label: string | null,
  value: number | null
) => {
  if (!isInitialized) return;
  ReactGA.event({
    category: category,
    action: action,
    label: label ?? undefined,
    value: value ?? undefined,
  });
};
